<template>
  <Modal v-model="show">
    <div slot="header" width="300">
      <span>新建目录</span>
    </div>
    <div>
      <Form
        ref="newForm"
        :model="newForm"
        :rules="rules"
        :label-width="80"
        size="small"
      >
        <FormItem :label="$t('message.newDialog.catalogName')" prop="name">
          <Input
            v-model="newForm.name"
            :placeholder="$t('message.newDialog.placeholder')"
          ></Input>
        </FormItem>
        <FormItem
          prop="selectedPath"
          :label="$t('message.newDialog.targetScriptPath')"
        >
          <directory-dialog
            :tree="arrToTree(tree)"
            :filter-node="filterNode"
            :path="selectedPath"
            class="save-as-modal-path"
            fs-type="api"
            @set-node="setNode"
          />
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="show = false">{{
        $t("message.constants.cancel")
      }}</Button>
      <Button
        type="primary"
        @click="submitForm('newForm')"
      >{{
        $t("message.constants.submit")
      }}</Button>
    </div>
  </Modal>
</template>
<script>
import directoryDialog from "@dss/js/component/directoryDialog/index.vue";

export default {
  name: "NewDialog",
  components: {
    directoryDialog,
  },
  props: {
    tree: {
      type: Array,
      default: () => [],
    },
    targetFolder: {
      type: String,
      default: "/",
    },
    id: {
      default: null,
    },
  },
  data() {
    return {
      show: false,
      newForm: {
        name: "",
      },
      parentId: null,
      selectedPath: "/",
      rules: {
        name: [
          {
            required: true,
            message: this.$t("message.newDialog.rules.catalogName.required"),
            trigger: "blur",
          },
          {
            min: 1,
            max: 200,
            message: this.$t("message.newDialog.rules.catalogName.lengthLimit"),
            trigger: "change",
          },
          {
            type: "string",
            pattern: /^[\w\u4e00-\u9fa5]+$/,
            message: this.$t(
              "message.newDialog.rules.catalogName.letterTypeLimit"
            ),
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    targetFolder(value) {
      this.selectedPath = value;
    },
    id(value) {
      this.parentId = value;
    },
  },
  methods: {
    open(data) {
      this.reset();
      this.show = true;
    },
    close() {
      this.show = false;
      this.reset();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update();
        }
      });
    },
    filterNode(node) {
      return !node.isLeaf;
    },
    update() {
      this.$emit("newNode", {
        name: this.newForm.name,
        parentId: this.parentId,
      });
      this.show = false;
    },
    setNode(node) {
      this.parentId = node.id;
      let temp = this.handleUrl(node.id, []);

      this.selectedPath = temp;
    },
    handleUrl(id, list) {
      let temp = this.tree.find((item) => {
        return item.id === id;
      });
      if (temp) {
        list.push(temp.name);
        if (temp.parentId) {
          return this.handleUrl(temp.parentId, list);
        }
      }
      return "/" + list.reverse().join("/");
    },
    arrToTree(arr, id = null) {
      const res = [];
      arr.forEach((item) => {
        item.isLeaf = item.leaf;
        if (item.parentId === id) {
          const children = this.arrToTree(
            arr.filter((v) => v.parentId !== id),
            item.id
          );
          if (children.length) {
            res.push({ ...item, children });
          } else {
            res.push({ ...item });
          }
        }
      });
      return res;
    },
    reset() {
      this.newForm = {
        name: ""
      };
      this.parentId = null;
      this.selectedPath = "/";
      this.$refs.newForm.resetFields();
    },
  },
};
</script>
<style>
.newDialog .ivu-select-dropdown-list {
  height: 200px;
}
</style>
